<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'
import axios from 'axios'

export default {
  page: {
    title: '360MDR Reports',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data () {
    return {
      finishedWidgetsCount: 0,
      showDownloadButton: false,
      widgetsStatus: [],
      companies: [],
      loadingCompanies: true,
      company: null,
      startDateTime: null,
      endDateTime: null,
      startDateTimeShow: null,
      endDateTimeShow: null,
      error: null,
      title: 'Reporte MDR por Compañía',
      startEpoch: 0,
      endEpoch: 0,
      date: null,
      dateTimePicker: {
        enableTime: true,
        dateFormat: 'm/d/Y H:i'
      },
      pdfConfig: {
        margin: 0.2,
        filename: 'Report by Company Corona.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        pagebreak: { mode: 'css', before: '#page2el' },
        _pageBreak: { mode: 'avoid-all', before: '.break-page', after: '.break-page' }
      },
      dashboard: {
        'widgets': [
          {
            'source': '/pan/xdr/count/timerange/other?collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident&match',
            'source_bak': '/pan/xdr/count/timerange/other?collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident',
            'id': 'w1',
            'name': 'incidentes totales en el rango de tiempo',
            'cols': 'col-md-6',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'range': true,
            'trend': false
          },
          {
            'source': '/pan/xdr/add/timerange/other?&collection=cortex_incidents&tvariable=incident.incident.creation_time&variable=incident.incident.alert_count',
            'id': 'w2',
            'name': 'Alertas totales en el rango de tiempo',
            'cols': 'col-md-6',
            'height_class': 'small',
            'component': 'vindicator',
            'refresh': 60000,
            'range': true,
            'trend': false
          },
          {
            'source': '/pan/xdr/agg/date/auto?collection=cortex_incidents&variable=incident.incident.creation_time&match=incident.incident.severity,high',
            'id': 'w3',
            'name': 'CANTIDAD DE INCIDENTES DE SEVERIDAD ALTA',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dbar',
            'type': 'bar',
            'colors': ['#DC001E'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/date/auto?collection=cortex_incidents&variable=incident.incident.creation_time',
            'id': 'w4',
            'name': 'CANTIDAD TOTAL DE INCIDENTES',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dbar',
            'type': 'bar',
            'colors': ['#0084FF'],
            'range': true,
            'refresh': 60000
          },
          {
            'id': 'w45',
            'source': '/pan/xdr/incidents/top?limit={$limit}&maxlength=800',
            'name': 'INCIDENTES MDR',
            'cols': 'col-md-12',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'card_style': '',
            'range': true,
            'limit': 200,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.severity&outvars=label&tvariable=incident.incident.creation_time&limit=3',
            'id': 'w5',
            'name': 'INCIDENTES POR SEVERIDAD',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dpie',
            'type': 'donut',
            'colorsByLabel': {
						  'high': '#DC001E',
              'medium': '#FECA00',
              'low': '#01AD00'
            },
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.status&outvars=label&tvariable=incident.incident.creation_time&limit=6',
            'source1': '/pan/xdr/agg/general?collection=cortex_incidents&variables=incident.incident.status&outvars=label&tvariable=incident.incident.modification_time&limit=6',
            'id': 'w6',
            'name': 'ACCIONES / EVENTOS',
            'cols': 'col-md-6',
            'height_class': 'tall_widget',
            'component': 'dpie',
            'type': 'donut',
            'colors': ['#0084FF', '#1ab7ea', '#0084ff', '#39539E', '#0077B5'],
            'range': true,
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?collection=cortex_incidents&variable=incident.alerts.data.description&outvars=reference&tvariable=incident.incident.creation_time&maxlength=100&limit=100',
            'name': 'DISTRIBUCÍON DE ALERTAS EN INCIDENTES',
            'id': 'w7',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay alertas en incidentes en el rango de tiempo para mostrar.',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.user_name',
            'name': 'DISTRIBUCÍON DE USUARIOS EN ALERTAS',
            'id': 'w8',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay usuarios en alertas en el rango de tiempo para mostrar.',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.category&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&uw=incident.alerts.data&limit=10&tkind=timestamp',
            'name': 'TIPOS DE ALERTAS',
            'id': 'w9',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay tipos de alertas en el rango de tiempo para mostrar.',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/top?collection=cortex_incidents&variables=incident.alerts.data.source&outvars=reference&tvariable=incident.alerts.data.detection_timestamp&uw=incident.alerts.data&limit=10&tkind=timestamp',
            'id': 'w10',
            'name': 'FUENTES DE ALERTAS',
            'cols': 'col-md-6',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay fuentes de alertas en el rango de tiempo para mostrar.',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.host_ip',
            'name': 'TOP DE HOSTS EN ALERTAS',
            'id': 'w11',
            'cols': 'col-md-4',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay hosts en alertas en el rango de tiempo para mostrar.',
            'refresh': 60000
          },
          {
            'source': '/pan/xdr/alerts/hip/top?variable=incident.alerts.data.name&maxlength=100',
            'name': 'TOP DE ALERTAS',
            'id': 'w12',
            'cols': 'col-md-8',
            'height_class': 'short_widget',
            'component': 'multicolumn',
            'range': true,
            'error': 'No hay alertas en el rango de tiempo para mostrar.',
            'refresh': 60000
          }
        ]
      },
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      base: 0
    }
  },
  computed: {

  },
  mounted () {
    this.showModal()
    this.loadCompanies()
  },
  methods: {
    downloadPdf () {
      const element = document.getElementById('pdfcontent')
      html2pdf(element, this.pdfConfig)
    },
    loadCompanies () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'

      // Check sessionStorage cache first (valid for 5 minutes)
      const cached = sessionStorage.getItem('mdr_companies')
      if (cached) {
        try {
          const { data, timestamp } = JSON.parse(cached)
          if (Date.now() - timestamp < 300000) {
            that.companies = data
            that.loadingCompanies = false
            return
          }
        } catch (e) {
          sessionStorage.removeItem('mdr_companies')
        }
      }

      axios.get(`${baseURL}/pan/xdr/distinct/netinfo.company`).then((response) => {
        if (response.status === 200) {
          that.companies = response.data.data.map(function (comp) {
            return { value: comp, text: comp }
          }) || []
          that.companies.unshift({ value: null, text: 'Please select an option...', disabled: true })

          // Cache in sessionStorage
          sessionStorage.setItem('mdr_companies', JSON.stringify({
            data: that.companies,
            timestamp: Date.now()
          }))
        }
      }).catch((error) => {
        console.error('Error loading companies:', error)
        that.error = 'Error loading companies. Please refresh the page.'
      }).finally(() => {
        that.loadingCompanies = false
      })
    },
    showModal () {
      this.$refs['modal-datetime'].show()
    },
    handleOk (evt) {
      // this.showGenerating = true
      let that = this
      if (that.startDateTime === null) {
        that.error = 'Please select a start date and time'
        evt.preventDefault()
      } else if (that.endDateTime === null) {
        that.error = 'Please select an end date and time'
        evt.preventDefault()
      } else if (that.company === null) {
        that.error = 'Please select a company'
        evt.preventDefault()
      } else {
        that.startEpoch = parseInt(new Date(that.startDateTime).getTime() / 1000)
        that.endEpoch = parseInt(new Date(that.endDateTime).getTime() / 1000)
        that.base += 100
        that.title = 'Reporte del Servicio de MDR de ' + that.company
        that.startDateTimeShow = that.startDateTime
        that.endDateTimeShow = that.endDateTime
        that.error = null
      }
      that.finishedWidgetsCount = 0
      that.widgetsStatus = []
      that.showDownloadButton = true
    },
    widgetFinished (id, ok, aux) {
      this.finishedWidgetsCount += 1
      this.widgetsStatus.push({ id: id, ok: ok, aux: aux })
    }
  }
}
</script>

<template>
  <Layout>
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <br>
      <!-- {{ finishedWidgetsCount }} - {{ dashboard.widgets.length }} -->
      <br>
      <!-- {{ widgetsStatus }}		 -->
      <template v-if="showDownloadButton">
        <div class="row">
          <div
            class="col-md-12"
            style="text-align:center;"
          >
            <template v-if="finishedWidgetsCount === dashboard.widgets.length">
              <b-button
                class="btn btn-primary btn-sm mr-1"
                variant="light"
                @click="downloadPdf"
              >
                Download PDF
              </b-button>
            </template>
            <template v-else>
              <span>
                Generating...
              </span>
            </template>
          </div>
        </div>
      </template>
      <div
        id="pdfcontent"
        style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;"
      >
        <section slot="pdf-content">
          <br><br>
          <div
            class="container"
            style="max-width: 1420px !important;"
          >
            <div class="row page-title">
              <div
                class="col-md-12 align-items-center"
                style="text-align:center"
              >
                <h2
                  style="align:center;cursor:pointer;"
                  @click="showModal"
                >
                  {{ title }}
                  <br>
                  <h4>
                    <template v-if="startDateTimeShow !== null">
                      {{ startDateTimeShow }}
                      &nbsp;-&nbsp;
                    </template>
                    <template v-if="endDateTimeShow !== null">
                      {{ endDateTimeShow }}
                    </template>
                  </h4>
                </h2>
              </div>
            </div>
            <div
              class="row"
              style="page-break-after:always; clear:both;"
            >
              <template v-for="(widget, index) in dashboard.widgets">
                <Widget
                  :id="widget.id"
                  :key="index + base"
                  :title="widget.name"
                  :component="widget.component"
                  :source="widget.source + '&match=netinfo.company,' + company"
                  :cols="widget.cols"
                  :trend="widget.trend"
                  :wclass="widget.class"
                  :type="widget.type"
                  :colors="widget.colors"
                  :colors-by-label="widget.colorsByLabel"
                  :range="widget.range"
                  :cardStyle="widget.card_style"
                  :start="startEpoch"
                  :end="endEpoch"
                  :error="widget.error"
                  :limit="widget.limit"
                  @finished="widgetFinished"
                />
              </template>
            </div>
          </div>
        </section>
      </div>
    </div>
    <b-modal
      id="incident.incident_id"
      ref="modal-datetime"
      size="xs"
      title="Select Time Range and Company"
      :ok-only="true"
      :centered="true"
      :no-fade="true"
      @ok="handleOk"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Start</label>
            <flat-pickr
              v-model="startDateTime"
              :config="dateTimePicker"
              class="form-control"
              placeholder="Date and Time"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>End</label>
            <flat-pickr
              v-model="endDateTime"
              :config="dateTimePicker"
              class="form-control"
              placeholder="Date and Time"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-sm-12">
          <div class="form-group mt-3 mt-sm-0">
            <label for="default">Company</label>
            <b-form-select
              v-model="company"
              :options="companies"
              :disabled="loadingCompanies"
              placeholder="Some text"
            />
            <small
              v-if="loadingCompanies"
              class="text-muted"
            >
              Loading companies...
            </small>
          </div>
        </div>
      </div>
      <div
        v-if="error !== null"
        class="row"
      >
        <div
          class="col-md-12 severity_high"
          style="text-align:center"
        >
          {{ error }}
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
  .testa {
	max-width: 600px;
  }

</style>
